export enum ClientTitle {
  Monsieur = 'M.',
  Madame = 'Mme',
  Docteur = 'Dr.',
  Mademoiselle = 'Mademoiselle',
  Professeur = 'Pr'
}
